<template>
  <v-container class="py-10">
    <!-- Selector de tipo de empresa -->
    <!-- Título del formulario -->
    <v-row justify="center">
      <v-col cols="12" md="8" class="text-center">
        <h2 class="display-1 font-weight-bold">
          Selecciona el tipo de empresa
        </h2>
      </v-col>
    </v-row>
    <v-row justify="center" class="mb-8">
      <v-col cols="12" md="4">
        <v-card
          outlined
          :class="companyType === 'us' ? 'selected-card' : ''"
          class="pa-4 text-center"
          elevation="7"
          style="border-radius: 12px; cursor: pointer;"
          @click="selectCompany('us')"
        >
          <v-img src="@/assets/usa_flag.svg" contain max-width="60" class="mb-2 mx-auto" />
          <h3 class="subtitle-1 font-weight-bold mb-0">Empresa Americana</h3>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          outlined
          :class="companyType === 'mx' ? 'selected-card' : ''"
          class="pa-4 text-center"
          elevation="7"
          style="border-radius: 12px; cursor: pointer;"
          @click="selectCompany('mx')"
        >
          <v-img src="@/assets/images/Flags_mex.svg" contain max-width="60" class="mb-2 mx-auto" />
          <h3 class="subtitle-1 font-weight-bold mb-0">Empresa Mexicana</h3>
        </v-card>
      </v-col>
    </v-row>

    <!-- Título del formulario -->
    <v-row justify="center" v-if="companyType">
      <v-col cols="12" md="8" class="text-center">
        <h2 class="display-1 font-weight-bold">
          Datos del representante legal de tu empresa
        </h2>
      </v-col>
    </v-row>

    <!-- Formulario -->
    <v-form ref="form" v-model="valid" v-if="companyType">
      <v-row>
        <!-- Nombre -->
        <v-col cols="12">
          <v-text-field
            v-model="form.nombre"
            label="Nombre(s)"
            :rules="[rules.required]"
            hint="Tal como aparece en tu identificación oficial vigente"
            persistent-hint
          />
        </v-col>

        <!-- Apellidos -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.apellidoPaterno"
            label="Apellido paterno"
            :rules="[rules.required]"
            hint="Tal como aparece en tu identificación oficial vigente"
            persistent-hint
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.apellidoMaterno"
            label="Apellido materno"
            hint="Tal como aparece en tu identificación oficial vigente"
            persistent-hint
          >
          </v-text-field>
        </v-col>

        <!-- Género -->
        <v-col cols="12" md="6">
          <v-select
            v-model="form.genero"
            :items="['Masculino', 'Femenino', 'Otro']"
            label="Género legal"
            :rules="[rules.required]"
          />
        </v-col>

        <!-- Email y Teléfono -->
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.email"
            label="Email corporativo"
            :rules="[rules.required, rules.email]"
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.telefono"
            label="Teléfono de contacto"
            :rules="[rules.required]"
          />
        </v-col>

        <!-- Nacionalidad y país -->
        <v-col cols="12" md="6">
          <v-select
            v-model="form.nacionalidad"
            :items="paises"
            label="Nacionalidad"
            :rules="[rules.required]"
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-select
            v-model="form.paisNacimiento"
            :items="paises"
            label="País de nacimiento"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.cargo"
            label="CURP"
            hint="*Tal como aparece en tu identificación (usa mayúsculas)"
            :rules="[rules.required]"
          />
        </v-col>

        <!-- Cargo y nombre legal -->
        <v-col cols="12">
          <v-text-field
            v-model="form.cargo"
            label="Cargo del representante autorizado que establece la relación bancaria"
            :rules="[rules.required]"
          />
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="form.nombreEmpresa"
            label="Nombre legal de la empresa"
            hint="Verifica que sea igual al de tu acta constitutiva"
            persistent-hint
            :rules="[rules.required]"
          />
        </v-col>
      </v-row>

      <!-- Botón -->
      <v-row justify="center" class="mt-6">
        <v-btn color="primary" rounded large @click="submit">
          Continuar
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      companyType: null, // 'mx' o 'us'
      valid: false,
      form: {
        nombre: '',
        apellidoPaterno: '',
        apellidoMaterno: '',
        sinApellidoMaterno: false,
        genero: '',
        email: '',
        telefono: '',
        nacionalidad: '',
        paisNacimiento: '',
        cargo: '',
        nombreEmpresa: '',
      },
      paises: ['México', 'Estados Unidos', 'Canadá', 'Colombia', 'Argentina'],
      rules: {
        required: value => !!value || 'Este campo es obligatorio',
        email: value => /.+@.+\..+/.test(value) || 'Correo inválido',
      },
    };
  },
  methods: {
    selectCompany(type) {
      this.companyType = type;
    },
    submit() {
      if (this.$refs.form.validate()) {
        // Aquí puedes continuar al siguiente paso o enviar el form
        console.log('Formulario válido', this.form);
        this.$router.push('/compliance'); // Ejemplo de navegación
      } else {
        console.log('Formulario inválido');
      }
    },
  },
};
</script>

<style scoped>
.selected-card {
  border: 2px solid #0275b8 !important;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 86, 255, 0.1);
}
</style>
